/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 01/18/2021
 *
 * @version 0.1
 * Revisions:
 * 01/18/2021 - BW - Initial Creation
 *
 * Description/Purpose:
 * Same DTO class in Java basically
 ************************************************************** */
import BasicAjaxResponseJSONDTO from "./basic-ajax-response-json-dto";

export default class PaymentProfileAjaxResponseJsonDTO extends BasicAjaxResponseJSONDTO {
  constructor(obj) {
    super(obj);
    if (obj) Object.assign(this, obj);
  }

  get customerPaymentProfileMaskedTypeList() {
    return this._customerPaymentProfileMaskedTypeList;
  }

  set customerPaymentProfileMaskedTypeList(newCustomerPaymentProfileMaskedTypeList) {
    this._customerPaymentProfileMaskedTypeList = newCustomerPaymentProfileMaskedTypeList;
  }
}
